export default __webpack_public_path__ + "static/shara-6d3444eec25c0bb1e88edc7a0b43350a.svg";